(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Collection', './demographicsModel', 'services/demographicsExtService', 'underscore'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var demographicsExtService = require('./../urls').demographicsExtService;
    var _ = require('underscore');
    module.exports = factory(require('backbone-torso/modules/Collection'), require('./demographicsModel'), demographicsExtService, _);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoCollection, demographicsModel, demographicsExtService, _) {
  'use strict';

  /**
   * @class DemographicsCollection
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: demographicsModel,
    url: demographicsExtService,
    fetchHttpAction: 'POST',

    /**
     * @method parse
     * @override
     */
    parse: function(responses) {
      return _.map(responses, demographicsModel.prototype.parse);
    },

    /**
     * Fetches patient vecna ids by demographics criteria
     * @method fetchPatientVecnaIdsByCriteria
     * @param [demographicsCriteria] {Object} demographics criteria
     * @return {Deferred} Promise from ajax request
     */
    fetchPatientVecnaIdsByCriteria: function (demographicsCriteria) {
      return $.ajax({
        url: demographicsExtService + '/search',
        contentType: 'application/json',
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(demographicsCriteria)
      });
    }
  }))();
}));
